import { z } from 'zod';
import { TenantIdSchema } from './common.js';

/*
 * Contrato 3: quem pode usar e o que pode ver.
 * Os papéis do Entra dizem só o que a pessoa pode fazer (Leitor, Editor, Admin). Os apps que ela
 * enxerga vêm da fonte, como ela (ADR 0036). O canal é o app cliente que pediu o token.
 * A section access da fonte continua decidindo as linhas.
 */

export const ToolNameSchema = z.enum([
  'search_context',
  'list_values',
  'run_validated_query',
  'explain_result',
  'resolve_question',
  'report_feedback',
  'query_metric',
  'list_apps',
  'describe_app',
  'query',
  'propose_context_change',
]);
export type ToolName = z.infer<typeof ToolNameSchema>;
export const ALL_TOOLS: readonly ToolName[] = ToolNameSchema.options;

/** Usuário já validado, como o núcleo recebe. Nunca é montado a partir de texto do agente. */
export const PrincipalSchema = z.object({
  /** Id estável do usuário no IdP (oid no Entra, sub em outros). */
  subject: z.string().min(1),
  /** Login do usuário (UPN no Entra). É a base da tradução para o usuário da fonte. */
  upn: z.string().min(1),
  name: z.string().optional(),
  tenant_id: TenantIdSchema,
  issuer: z.string().min(1),
  roles: z.array(z.string()),
  /** App cliente que pediu o token (azp/appid). Identifica o canal. */
  client_app: z.string().nullable(),
  channel: z.string().min(1),
  /** Claims extras que a regra de usuário de alguma fonte pode usar (ex.: onprem_sam_account_name). */
  claims: z.record(z.string(), z.union([z.string(), z.array(z.string())])).default({}),
});
export type Principal = z.infer<typeof PrincipalSchema>;
